<script setup>
const localesWithBorder = ['JP', 'PL', 'RU', 'FR', 'IT', 'KR'];

const { locale, locales, setLocale } = useI18n();

const localeData = computed(() =>
  locales.value.find((localeData) => localeData.code === locale.value),
);

defineProps({
  triggerEvent: {
    type: String,
    default: undefined,
  },
});

function onLocalChange(locale, close) {
  if (!locale || !close || !setLocale) return;

  setLocale(locale);
  close();
}
</script>

<template>
  <UiDropdown
    class="bundles-lang-select"
    position="bottom"
    :trigger-event="triggerEvent"
    use-v-if
  >
    <template #trigger>
      <div class="bundles-lang-select__trigger">
        <slot />

        <CCountryFlag
          :key="localeData.region"
          class="bundles-lang-select__flag bundles-lang-select__flag--trigger"
          :code="localeData.region"
          :with-border="localesWithBorder.includes(localeData.region)"
          is-rounded
        />
      </div>
    </template>

    <template #content="{ close }">
      <ul class="bundles-lang-select__list">
        <li
          v-for="localeItem in locales"
          :key="localeItem.code"
          class="bundles-lang-select__item"
          :class="{
            'bundles-lang-select__item--selected': locale === localeItem.code,
          }"
          @click="onLocalChange(localeItem.code, close)"
        >
          <CCountryFlag
            class="bundles-lang-select__flag"
            :code="localeItem.region"
          />

          <span class="bundles-lang-select__font">
            {{ localeItem.localizedName }}
          </span>
        </li>
      </ul>
    </template>
  </UiDropdown>
</template>

<style scoped lang="scss">
.bundles-lang-select {
  &__font {
    font-size: em(17);
    line-height: math.div(24, 17);
  }

  &__trigger {
    display: flex;
    gap: em(12);
    align-items: center;
    cursor: pointer;
  }

  &__flag {
    flex-shrink: 0;
    height: em(18);
    width: em(29);
    margin-inline-end: em(10);

    &--trigger {
      @include box(em(35));

      @include media-breakpoint-down(sm) {
        @include box(em(30));

        margin-inline-end: 0;
      }
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    max-height: em(224);
    padding-block: em(28) em(28);
    padding-inline: em(35) em(35);
    overflow: hidden auto;
    background-color: $color-white;
    border: 1px solid $color-gray-8;
    border-radius: em(8);
  }

  &__item {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    color: $color-black;
    white-space: nowrap;
    cursor: pointer;
    transition: color $time-3;

    & + & {
      margin-top: em(15);
    }

    @include hover {
      color: $color-second-1;
    }

    &--selected {
      color: $color-second-1;
    }
  }
}
</style>
